export const initialState = {
  clinics: []
};
